module.exports = __webpack_public_path__ + "img/f05b2eb.png";